import React from "react";
import "../styles/Dashboard.css";

const Settings = ({ isSidebarOpen }) => {
  return (
    <div className={`msd-container ${isSidebarOpen ? "shifted" : ""}`}>
      <div className="msd-card">
        <div className="msd-card__head">
          <div>
            <div className="msd-card__title">Settings</div>
            <div className="msd-card__subtitle">Manage application preferences</div>
          </div>
        </div>
        <div className="msd-card__body">
          <p className="msd-muted">Coming soon</p>
        </div>
      </div>
    </div>
  );
};

export default Settings;
